export const search_list = [
  {
    type: "input",
    label: "课程名称",
    props: "course_name",
  },
  {
    type: "input",
    label: "课程类别",
    props: "course_type",
  },
  {
    type: "select",
    label: "状态",
    props: "audit_status",
    selectData: [
      {
        label: "待审核",
        value: "0",
      },
      {
        label: "审核通过",
        value: "1",
      },
      {
        label: "审核拒绝",
        value: "2",
      },
    ],
  },
  {
    type: "date",
    label: "时间",
    props: "course_time",
  },
];

export const tableColumns = [
  {
    title: "课程名称",
    value: "course_name",
    header_align: "center",
    align: "center",
    width: 180,
  },
  {
    title: "课程类别",
    value: "course_type",
    header_align: "center",
    align: "center",
    width: 120,
  },
  {
    title: "课程开始时间",
    value: "course_start_time",
    header_align: "center",
    align: "center",
    width: 180,
  },
  {
    title: "课程结束时间",
    value: "course_end_time",
    header_align: "center",
    align: "center",
    width: 180,
  },
  {
    title: "授课形式",
    value: "teach_mode_text",
    header_align: "center",
    align: "center",
    width: 100,
  },
  {
    title: "课程费用",
    value: "course_fee_text",
    header_align: "center",
    align: "center",
    width: 100,
  },
  {
    title: "发布时间",
    value: "created_at",
    header_align: "center",
    align: "center",
    width: 180,
  },
  {
    title: "状态",
    value: "audit_status_text",
    header_align: "center",
    align: "center",
    width: 100,
  },
];

export const actionGroup = [
  {
    name: "审核",
    flag: "review",
    rules: "audit_status==0",
  },
  {
    name: "查看",
    flag: "detail",
    rules: "audit_status!=0",
  },
];

export const detailForm = [
  {
    type: "input",
    label: "课程名称",
    props: "course_name",
    placeholder: "请输入课程名称",
  },
  {
    type: "date",
    label: "课程时间",
    props: "course_time",
    propsConfig: {
      showTime: true,
    },
  },
  {
    type: "select",
    label: "授课形式",
    props: "teach_mode",
    placeholder: "请选择授课形式",
    selectData: [
      {
        label: "线上",
        value: '1',
      },
      {
        label: "线下",
        value: '2',
      },
    ],
  },
  {
    type: "select",
    label: "课程状态",
    props: "course_status",
    placeholder: "请选择课程状态",
    selectData: [
      {
        label: "未开始",
        value: "0",
      },
      {
        label: "进行中",
        value: "1",
      },
      {
        label: "已结束",
        value: "2",
      },
    ],
  },
  {
    type: "input",
    label: "课程费用",
    props: "course_fee",
    placeholder: "请输入课程费用",
  },
  {
    type: "slot",
    label: "课程封面图",
    props: "cover",
  },
  {
    type: "input",
    label: "联系人",
    props: "contact_name",
    placeholder: "请输入联系人",
    gridValue: 12,
  },
  {
    type: "input",
    label: "联系人电话",
    props: "contact_mobile",
    placeholder: "请输入联系人电话",
    gridValue: 12,
  },
  {
    type: "input",
    label: "详细地址",
    props: "address",
    placeholder: "请输入详细地址",
    gridValue: 12,
  },
  {
    type: "slot",
    label: "课程介绍",
    props: "description",
  },
];
